import Validation from "./Validation";
import primaryComponents from "../../primaryComponents";
import styles from "./styles.module.scss";
import useChartAccountLogic from "./useBankAccountLogic";
import { useRef } from "react";

const AddChartAccount = ({
  bankInfo,
  isEditMode = false,
  handleFetchAccountsList = () => {},
  closeWidget = () => {},
}) => {
  const {
    bankDetails,
    setBankDetails,
    handleAddChartAccount,
    handleEditChartAccount,
    updateChartAccountMutation,
    createChartAccountMutation,
    accountTypes,
    isLoadingAccountTypes,
  } = useChartAccountLogic({
    closeWidget,
    bankInfo,
    handleFetchAccountsList,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = Validation({ bankDetails });
  const subAccountTypeInputRef = useRef(null);

  return (
    <div className={styles.allAccounting}>
      <div className="">
        <div className={styles.formSection}>
          <div className="w-100 cover">
            <primaryComponents.SelectFieldV2
              control={control}
              isRequired={true}
              classNames="white"
              isDisabled={isEditMode}
              name="accountType"
              placeholder={
                isLoadingAccountTypes
                  ? "Loading account types..."
                  : "Account Type"
              }
              label="Account Type"
              options={accountTypes}
              nameKey="label"
              idKey="value"
              value={bankDetails?.account_type}
              onChange={(value) => {
                setBankDetails((prev) => ({
                  ...prev,
                  account_type: value,
                  sub_account_type: "",
                }));
              }}
              errorMessage={errors.accountType}
              register={register}
            />
          </div>
          <div className="w-100 cover">
            <primaryComponents.TwoStepSelectFieldV2
              control={control}
              isRequired={true}
              classNames="white"
              isDisabled={isEditMode}
              name="subAccountType"
              selectInputRef={subAccountTypeInputRef}
              placeholder={
                isLoadingAccountTypes
                  ? "Loading sub account types..."
                  : "Sub Account Type"
              }
              label="Sub Account Type"
              options={
                accountTypes.find(
                  (accountType) =>
                    accountType.value === bankDetails?.account_type,
                )?.categories || []
              }
              nameKey="label"
              idKey="value"
              subKey="sub_account_types"
              value={bankDetails?.sub_account_type}
              onChange={(value) => {
                setBankDetails((prev) => ({
                  ...prev,
                  sub_account_type: value,
                }));
              }}
              errorMessage={errors.subAccountType}
              register={register}
            />
          </div>
          <div className="w-100 cover">
            <primaryComponents.InputFieldV2
              control={control}
              isRequired={true}
              classNames="white"
              name="accountName"
              label="Account Name"
              placeholder="Enter account name"
              value={bankDetails?.account_name}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  account_name: value,
                }));
              }}
              errorMessage={errors.accountName}
              onKeyUp={() =>
                errors.accountName !== undefined && trigger("accountName")
              }
              register={register}
            />
          </div>
          {!isEditMode && (
            <div className={`w-100 cover ${styles.formFieldRow}`}>
              <primaryComponents.AmountFieldV2
                control={control}
                classNames="white"
                name="openingBalance"
                label="Opening Balance"
                placeholder="Enter opening balance"
                value={bankDetails?.opening_balance}
                onChange={({ target: { value } }) => {
                  setBankDetails((prev) => ({
                    ...prev,
                    opening_balance: value,
                  }));
                }}
                errorMessage={errors.openingBalance}
                onKeyUp={() =>
                  errors.openingBalance !== undefined &&
                  trigger("openingBalance")
                }
                register={register}
              />
              <primaryComponents.DateInputV2
                control={control}
                classNames="white w-100"
                name="balanceDate"
                label="Balance Date"
                value={bankDetails?.balance_date}
                onChange={({ target: { value } }) => {
                  setBankDetails((prev) => ({
                    ...prev,
                    balance_date: value,
                  }));
                }}
                errorMessage={errors.balanceDate}
                onKeyUp={() =>
                  errors.balanceDate !== undefined && trigger("balanceDate")
                }
                register={register}
              />
            </div>
          )}
          <div className="w-100 cover">
            <primaryComponents.TextAreaV2
              control={control}
              label={
                <span>
                  Notes <span className="small">(Optional)</span>
                </span>
              }
              name="description"
              isRequired={false}
              type="text"
              placeholder="Add internal note about this account"
              value={bankDetails?.description}
              classNames="white"
              errorMessage={errors.description}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  description: value,
                }));
              }}
              onKeyUp={() =>
                errors.description !== undefined && trigger("description")
              }
            />
          </div>
        </div>
      </div>

      {isEditMode ? (
        <primaryComponents.Button
          onClick={handleSubmit(handleEditChartAccount)}
          classNames="btn btn--primary cover mt-auto"
          isDisabled={updateChartAccountMutation.isLoading}
          isLoading={updateChartAccountMutation.isLoading}
          loadingText={"Updating..."}
        >
          Update Account
        </primaryComponents.Button>
      ) : (
        <primaryComponents.Button
          onClick={handleSubmit(handleAddChartAccount)}
          classNames="btn btn--primary cover mt-auto"
          isDisabled={createChartAccountMutation.isLoading}
          isLoading={createChartAccountMutation.isLoading}
          loadingText={"Adding..."}
        >
          Add Account
        </primaryComponents.Button>
      )}
    </div>
  );
};

export default AddChartAccount;
